export enum UserStatus {
  INACTIVE = 'inactive',
  ACTIVE = 'active'
}
